import { ComplianceStepType } from '@ping/api';
import PendingIcon from '@ping/assets/Icon/pending.svg';
import { modalKeys } from '@ping/constants/modal-keys.constant';
import { t } from '@ping/helpers';
import { useRemoteModal } from '@ping/hooks';
import { userInformationStore } from '@ping/stores/userInformation.store';
import { ButtonA11Y, Modal } from '@ping/uikit';

import style from './style.module.scss';

export const PendingForReviewModal = () => {
  const modal = useRemoteModal(modalKeys.PENDING_FOR_REVIEW);

  const handleOnContinue = async () => {
    userInformationStore.setComplianceStep(ComplianceStepType.PendingForReview);
    modal.state.close();
  };

  return (
    <Modal.Root {...modal.props}>
      <Modal.Portal className={style['pending-for-review-modal']}>
        <Modal.Content className={style['pending-for-review-modal__content']}>
          <PendingIcon className={style['pending-for-review-modal__icon']} />
          <Modal.Title className={style['pending-for-review-modal__title']}>{t('Pending for review')}</Modal.Title>
          <Modal.Subtitle className={style['pending-for-review-modal__description']} data-variant='mobile'>
            {t('Thank you for providing the required information. Your account is now under review.')}
          </Modal.Subtitle>
          <Modal.Subtitle className={style['pending-for-review-modal__description']} data-variant='desktop'>
            {t('Thank you for providing the required information.')}
          </Modal.Subtitle>
          <Modal.Subtitle className={style['pending-for-review-modal__description']} data-variant='desktop'>
            {t('Your account is now under review')}
          </Modal.Subtitle>
        </Modal.Content>

        <Modal.Actions className={style['pending-for-review-modal__actions']}>
          <ButtonA11Y className={style['pending-for-review-modal__continue']} onPress={handleOnContinue}>
            {t('Continue')}
          </ButtonA11Y>
        </Modal.Actions>
      </Modal.Portal>
    </Modal.Root>
  );
};
